export default "__VITE_ASSET__BBWr_4fq__"